<div class="h-100 d-flex flex-column justify-content-between sale-accelerator">
  <div class="d-flex flex-column">
    <img class="sales-image" [src]="item.image" />
    <div class="d-flex flex-column p-3 justify-content-center">
      <div class="title w-100 mb-3">
        <h3>{{ item.title }}</h3>
      </div>
      <div class="description w-100" [innerHtml]="item.content"></div>
    </div>
  </div>
  <div class="d-flex flex-column">
    <div class="ms-3 my-1" [innerHTML]="item.footerContent"></div>
    <hr class="m-0 mx-3" />
    <div class="ms-1 my-2 d-flex justify-content-between align-items-center">
      <button class="btn btn-link" (click)="openMessage(item.dialogMessage)">
        {{ 'Find Out More' | translate }} <fa-icon [icon]="['far', 'chevron-right']"></fa-icon>
      </button>
      <img class="footer-image" [src]="item.footerImage" />
    </div>
  </div>
</div>
